import { render } from "./ifu-documentation.vue?vue&type=template&id=10aba945&scoped=true"
import script from "./ifu-documentation.vue?vue&type=script&lang=js"
export * from "./ifu-documentation.vue?vue&type=script&lang=js"

import "./ifu-documentation.vue?vue&type=style&index=0&id=10aba945&scoped=true&lang=css"

import exportComponent from "/Users/skynet/Documents/Sites Safe OK MAIS PEUT ETRE PAS A JOUR/Safe_Sites_Modifs/SAFE_ORTHO/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10aba945"]])

export default __exports__